import { createRoot } from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import App from './routes/app-routes';
import { theme } from '@bemap/ui';
import { AuthProvider, initializeAPI } from '@bemap/utils'
import './i18n'

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://7213fd243950eec0825e56fcdc320a25@o4510240297058304.ingest.us.sentry.io/4510240298631168",
  sendDefaultPii: true,
  release: 'bemap-clients@' + __APP_VERSION__,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  enableLogs: true,
});

initializeAPI(import.meta.env.VITE_API_URL)

createRoot(document.getElementById('root')!).render(
  <BrowserRouter
    future={{
      v7_relativeSplatPath: true,
    }}>
    <AuthProvider>
      <ChakraProvider theme={theme}>
        <App />
      </ChakraProvider>
    </AuthProvider>
  </BrowserRouter>
); 